export class LanguageUtils {
    static getLanguage() {
        let defaultLanguage = 'es-ES';
        // get current url
        let url = window.location.href;
        // get the language
        let language = url.split('/')[3];
        switch (language) {
            case 'es':
                defaultLanguage = 'es-ES';
                break;
            case 'ca':
                defaultLanguage = 'ca-ES';
                break;
            case 'en':
                defaultLanguage = 'en-GB';
                break;
            case 'fr':
                defaultLanguage = 'fr-FR';
                break;
            default:
                defaultLanguage = 'es-ES';
                break;
        }
        return defaultLanguage;
    }

    static getLang() {
        // get current url
        let url = window.location.href;
        // get the language
        let language = url.split('/')[3];
        if (language === 'es' || language === 'ca' || language === 'en' || language === 'fr') {
            return language;
        } else {
            return 'es';
        }
    }
}